module.exports = __webpack_public_path__ + "static/oolie-c81865790e8b53be55e73abe61476e8d.gif";